export class Seat {
    constructor(id, round, table, user) {
        this.id = id;
        this.round = round;
        this.table = table;
        this.user = user;
    }
}